import { RouteRecordRaw } from 'vue-router'

import ViewAccount from '@/views/account/AccountView.vue';
import ViewLoginAccount from '@/views/account/LoginView.vue';
import ViewRegisterAccount from '@/views/account/RegisterView.vue';
import ViewAppointment from '@/views/account/AppointmentView.vue';
import CancelAppointment from '@/views/account/AppointmentCancel.vue';
import ViewCounselingCenter from '@/views/ergebnisliste/ViewCounselingCenter.vue';

const routesWidgetAccount: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'widget-appointment',
    beforeEnter: (to, from, next) => {
      const user = sessionStorage.getItem('user');
      const token = sessionStorage.getItem('token');
      if (user && token && user != '' && token != '') {
        next();
      } else {
        next({ path: '/login' });
      }
    },
    props:true,
    component: ViewAppointment,
  },
  {
    path: '/appointment/cancel/:id',
    name: 'widget-appointment-cancel',
    beforeEnter: (to, from, next) => {
      const user = sessionStorage.getItem('user');
      const token = sessionStorage.getItem('token');
      if (user && token && user != '' && token != '') {
        next();
      } else {
        next({ path: '/login' });
      }
    },
    props: true,
    component: CancelAppointment,
  },
  {
    path: '/account',
    name: 'widget-account',
    beforeEnter: (to, from, next) => {
      const user = sessionStorage.getItem('user');
      const token = sessionStorage.getItem('token');
      if (user && token && user != '' && token != '') {
        next();
      } else {
        next({ path: '/login' });
      }
    },
    component: ViewAccount,
  },
  {
    path: '/login',
    name: 'login',
    component: ViewLoginAccount,
    props: { default: true }
  },
  {
    path: '/register',
    name: 'register',
    component: ViewRegisterAccount,
    props: { default: true }
  },
  {
    path: '/counseling-center/:ccid',
    name: 'counseling-center',
    component: ViewCounselingCenter,
    props: { default: true }
  },
 /*  {
    path: '/:pathMatch(.*)*',
    redirect: to => {
      if (to.path == "/main" || to.path == "/navDesk") {
        return {
          path: '/',
          hash: to.path.substring(1)
        }
      } else {
        return {
          path: '/'
        }
      }

    },
  } */
]

export default routesWidgetAccount
